<div class="menu-container">
    <div class="top-row">
        <img src="../../../assets/img/vierkantai.png" alt="Logo" class="logo" />
        <div class="top-row-actions">
            @if (dashboardVisible()) {
                <a class="switcher-btn focus-ring" matRipple
                   routerLinkActive="active"
                   title="Dashboard"
                   [routerLink]="['statistics']"
                   (click)="selectedNode.set(null)">
                    <mat-icon class="material-symbols-outlined">dashboard</mat-icon>
                </a>
            }
            <button type="button" class="switcher-btn more-btn focus-ring" matRipple #switcherTrigger
                    [class.active]="switcherOpen()"
                    [attr.aria-expanded]="switcherOpen()"
                    aria-controls="app-switcher-section"
                    title="Menü"
                    (click)="toggleSwitcher()">
                <mat-icon class="material-symbols-outlined">apps</mat-icon>
            </button>
        </div>
    </div>

    <!-- App-Switcher: bleibt in der Menueleiste und klappt zwischen Kopfbereich und Navigation nach
         unten auf, statt seitlich darueber zu liegen - die Navigation rutscht dabei mit nach unten.
         Immer im DOM (fuer die Auf-/Zuklapp-Animation), im zugeklappten Zustand per inert komplett
         aus Fokus- und Klickreihenfolge genommen. -->
    <div class="switcher-section" id="app-switcher-section" #switcherSection
         [class.open]="switcherOpen()"
         [attr.inert]="switcherOpen() ? null : ''">
        <div class="switcher-section-inner">
            <div class="app-switcher">
                @for (item of switcherItems(); track item.key) {
                    @if (showSwitcherItem(item)) {
                        @if (item.children) {
                            <button type="button" class="switcher-btn focus-ring" matRipple
                                    [class.active]="activeSection() === item.key"
                                    [attr.aria-pressed]="activeSection() === item.key"
                                    [title]="item.badge ? item.label + ' – ' + item.badge : item.label"
                                    (click)="selectSection(item); closeSwitcher()">
                                <mat-icon class="material-symbols-outlined">{{ item.icon }}</mat-icon>
                                <span class="switcher-label truncate">{{ item.label }}</span>
                                @if (item.badge) { <span class="switcher-badge">{{ item.badge }}</span> }
                            </button>
                        } @else {
                            <a class="switcher-btn focus-ring" matRipple
                               [class.active]="activeSection() === item.key"
                               [title]="item.label"
                               [routerLink]="item.path"
                               (click)="closeSwitcher()">
                                <mat-icon class="material-symbols-outlined">{{ item.icon }}</mat-icon>
                                <span class="switcher-label truncate">{{ item.label }}</span>
                            </a>
                        }
                    }
                }
            </div>
        </div>
    </div>

    <div class="flex-grow-1 nav-scroll">
        @if (activeSectionNodes(); as section) {
            <div class="section-heading">
                <mat-icon class="section-heading-icon material-symbols-outlined">{{ section.icon }}</mat-icon>
                <span class="truncate">{{ section.label }}</span>
            </div>
            @if (section.children.length) {
                <tree-view
                  [nodes]="section.children"
                  [selectedNodeId]="selectedNode()"
                  (selectedNodeChange)="selectedNode.set($event)">
                </tree-view>
            }
        }
    </div>

    <div class="footer">
      @if (settingsVisible()) {
          <div class="entry settings-entry" matRipple
               [class.active]="settingsActive()"
               (click)="selectSettings()">
              <mat-icon class="entry-icon">settings</mat-icon>
              <span class="entry-label truncate">Einstellungen</span>
          </div>
      }
      <div class="entry notification-center" matRipple (click)="openNotifications()" [matBadge]="notificationStatus()" [matBadgeHidden]="notificationStatus() === 0">
        <mat-icon class="entry-icon">notifications</mat-icon>
        <span class="entry-label truncate">Benachrichtigungen</span>
      </div>
      <div class="entry logout">
          <div class="avatar">{{ userInitial() }}</div>
          <div class="user-email truncate" [title]="userInfo()">{{ userInfo() }}</div>
          <button matIconButton class="logout-button" (click)="openLogoutDialog('0ms', '0ms')" title="Abmelden">
            <mat-icon>logout</mat-icon>
          </button>
      </div>
    </div>
</div>

<ng-template #logoutTemplate>
</ng-template>
